angular
    .module('festzelt-os.modules.wallets.templates')
    .factory('WalletTemplate', [
        'locale',
        'Resource',
        WalletTemplate
    ]);

function WalletTemplate(locale, Resource) {
    return Resource.make('passbooks');
}



// WEBPACK FOOTER //
// ./src/app/modules/wallets/templates/factories/template.js